/* 遵循ant-design-pro定义接口规范 */
/* https://github.com/ant-design/ant-design-pro */

import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"
import type { NoticeData } from "./type"

/** 获取所有消息 */
export async function noticeGetList(data: { limit: number, offset: number, status?: string | null, type?: string }): Promise<{ total: number, rows: Array<NoticeData> }> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<{ total: number, rows: Array<NoticeData> }>('/v1/api/notice/message', data)
}

/** 已读一条/全部消息 */
export async function noticeSeed(ArrayId?: { noticeIds: number[] }): Promise<unknown> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.put<unknown>('/v1/api/notice/message', ArrayId)
}

/** 删除一条/全部消息 */
export async function noticeDelete(ArrayId?: string): Promise<unknown> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.delete<unknown>('/v1/api/notice/message/' + ArrayId)
}
